/*
 * Author: Duncan Levings
 * 
 * Copyright (c) 2020 DuncanLevings
 */

// PRESETS

export const GET_PRESETS = 'GET_PRESETS';
export const GET_PRESETS_SUCCESS = 'GET_PRESETS_SUCCESS';

export const GET_PRESET_SINGLE = 'GET_PRESET_SINGLE';
export const GET_PRESET_SINGLE_SUCCESS = 'GET_PRESET_SINGLE_SUCCESS';

export const CREATE_PRESET = 'CREATE_PRESET';
export const CREATE_PRESET_SUCCESS = 'CREATE_PRESET_SUCCESS';

export const EDIT_PRESET = 'EDIT_PRESET';
export const EDIT_PRESET_SUCCESS = 'EDIT_PRESET_SUCCESS';

export const DELETE_PRESET = 'DELETE_PRESET';
export const DELETE_PRESET_SUCCESS = 'DELETE_PRESET_SUCCESS';

export const SAVE_PRESET = 'SAVE_PRESET';
export const CLEAR_PRESET = 'CLEAR_PRESET';

// ERROR

export const CLEAR_ERRORS = 'CLEAR_ERRORS';
export const ERROR = 'PRESET_ERROR';